import { useControlledState } from '../../hooks/useControlledState';
/**
 * Represents the available `action` types for the `SchedulerItemShowOccurrenceDialogAction` objects.
 *
 * The available actions are:
 * - `SHOW_OCCURRENCE_DIALOG_SET`
 * - `SHOW_OCCURRENCE_DIALOG_OPEN`
 * - `SHOW_OCCURRENCE_DIALOG_CLOSE`
 * - `SHOW_OCCURRENCE_DIALOG_RESET`
 * - `SHOW_OCCURRENCE_DIALOG_TOGGLE`
 */
export var SHOW_OCCURRENCE_DIALOG_ACTION;
(function (SHOW_OCCURRENCE_DIALOG_ACTION) {
    SHOW_OCCURRENCE_DIALOG_ACTION["set"] = "SHOW_OCCURRENCE_DIALOG_SET";
    SHOW_OCCURRENCE_DIALOG_ACTION["open"] = "SHOW_OCCURRENCE_DIALOG_OPEN";
    SHOW_OCCURRENCE_DIALOG_ACTION["close"] = "SHOW_OCCURRENCE_DIALOG_CLOSE";
    SHOW_OCCURRENCE_DIALOG_ACTION["reset"] = "SHOW_OCCURRENCE_DIALOG_RESET";
    SHOW_OCCURRENCE_DIALOG_ACTION["toggle"] = "SHOW_OCCURRENCE_DIALOG_TOGGLE";
})(SHOW_OCCURRENCE_DIALOG_ACTION || (SHOW_OCCURRENCE_DIALOG_ACTION = {}));
var showOccurrenceDialogReducer = function (state, action) {
    switch (action.type) {
        case SHOW_OCCURRENCE_DIALOG_ACTION.reset:
            return false;
        case SHOW_OCCURRENCE_DIALOG_ACTION.set:
            return action.payload;
        case SHOW_OCCURRENCE_DIALOG_ACTION.open:
            return true;
        case SHOW_OCCURRENCE_DIALOG_ACTION.close:
            return false;
        case SHOW_OCCURRENCE_DIALOG_ACTION.toggle:
            return !state;
        default:
            return state;
    }
};
/** @hidden */
export var useShowOccurrenceDialog = function (defaultProp, prop, callback) {
    var _a = useControlledState(defaultProp, prop, callback), showOccurrenceDialog = _a[0], setShowOccurrenceDialog = _a[1];
    var handleShowOccurrenceDialogAction = function (action) {
        var newShowOccurrenceDialog = showOccurrenceDialogReducer(showOccurrenceDialog, action);
        setShowOccurrenceDialog(newShowOccurrenceDialog);
    };
    return [showOccurrenceDialog, setShowOccurrenceDialog, handleShowOccurrenceDialogAction];
};
//# sourceMappingURL=use-show-occurrence-dialog.js.map